import { render, staticRenderFns } from "./logical.vue?vue&type=template&id=695433bc&"
import script from "./logical.vue?vue&type=script&lang=js&"
export * from "./logical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports